module.exports = __webpack_public_path__ + "img/233.5870fa4b.png";